import React from "react";
import PageHeader from "./global-components/page-header";
import DodatneUsluge from "./section-components/dodatne-usluge";

import Footer from "./global-components/footer";
import usePageMeta from "./global-components/use-page-meta";

const Usluge = () => {
  usePageMeta(
    "Dizajn, print i montaža reklamnih panoa | Prokurator Split",
    "Grafički dizajn, printanje, izrada reklamnih panoa i putokaza, montaža i lijepljenje reklamne folije — uz najam oglasnih površina, iz Splita."
  );

  return (
    <div>
      <PageHeader headertitle="Lokacije" />
      <DodatneUsluge />
      <Footer />
    </div>
  );
};

export default Usluge;
